import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';

// Pages (move these to src/pages/)
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyMail from './pages/VerifyMail';
import ForgetPassword from './pages/ForgetPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import ChangePassword from './pages/ChangePassword';
import WhatsAppFloating from './components/WhatsAppFloating';

const App = () => {
  return (
    <Router>
      <Header />
        <WhatsAppFloating
          message="مرحبا! أحتاج مساعدة بخصوص الخدمة."
          position="right"                      // أو "left" لو واجهتك RTL
          bottom={20}
        />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-mail" element={<VerifyMail />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route element={<ProtectedRoute />}>
          {/* <Route path="/verify-phone-number" element={<VerifyPhone />} /> */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/change-password" element={<ChangePassword />} />
        </Route>

      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
